import {
  ButtonGroup,
  MenuItem,
  FormControl,
  Grid,
  Select,
  TextField,
  InputLabel
} from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import { Heading } from './common/Heading';
import { useDispatch } from 'react-redux';
import * as React from 'react';

function ToolBarOrganisation({ setSearchInputText, searchInputText, setOrgType, setStatus, title = 'Video' +
  ' Library' }) {
  const dispatch = useDispatch();

  const changeData =
    key =>
    ({ target: { value } }) =>
      setSearchInputText({
        ...searchInputText,
        [key]: value,
      });

  const handleSubmit = e => {
    e.preventDefault();
    dispatch({ type: 'SET_VIDEO_LIBRARY_SEARCH_TEXT', payload: searchInputText.searchText });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Toolbar style={{ paddingBottom: '45px', paddingLeft: '15px' }}>
        <Grid container alignItems={'center'} justifyContent={'space-between'} gap={'8px'}>
          <Grid item>
            <Heading>{title}</Heading>
          </Grid>

          <Grid item>
            <ButtonGroup>
              <FormControl
                variant="outlined"
                margin="dense"
                style={{
                  marginTop: '0px',
                  marginBottom: '0px',
                }}
              >
                <InputLabel id="select-organisation-label">Type</InputLabel>
                <Select
                  id="select-organisation"
                  defaultValue={'all'}
                  label={'Type'}
                  onChange={(e) => {
                    setOrgType(e.target.value);
                  }}
                  sx={{
                    fontFamily: 'ProximaNovaBold',
                    textTransform: 'none',
                    color: '#000',
                    height: '43px',
                    width: '200px',
                    marginRight: '0',
                  }}
                >
                  <MenuItem value={'all'}>All</MenuItem>
                  <MenuItem value={'publisher'}>Publisher</MenuItem>
                  <MenuItem value={'advertiser'}>Advertiser</MenuItem>
                  <MenuItem value={'rightsholder'}>Rightsholder</MenuItem>
                </Select>
              </FormControl>
            </ButtonGroup>
          </Grid>

          <Grid item>
            <ButtonGroup>
              <FormControl
                variant="outlined"
                margin="dense"
                style={{
                  marginTop: '0px',
                  marginBottom: '0px',
                }}
              >
                <InputLabel id="select-organisation-label">Status</InputLabel>
                <Select
                  id="select-status"
                  defaultValue={true}
                  label={'Status'}
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                  sx={{
                    fontFamily: 'ProximaNovaBold',
                    textTransform: 'none',
                    color: '#000',
                    height: '43px',
                    width: '200px',
                    marginRight: '0',
                  }}
                >
                  <MenuItem value={'true'}>Active</MenuItem>
                  <MenuItem value={'false'}>In Active</MenuItem>
                </Select>
              </FormControl>
            </ButtonGroup>
          </Grid>


          <Grid item flex={1}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type={'text'}
                value={searchInputText.searchText}
                label="Search text"
                variant="outlined"
                placeholder={'Search text'}
                onChange={changeData('searchText')}
              />
            </FormControl>
          </Grid>
          <Grid item>
          </Grid>
        </Grid>
      </Toolbar>
    </form>
  );
}

export default styled(ToolBarOrganisation)`
  margin-bottom: 40px;
`;
